import { trackEvent } from '../../../modules/analytics';

const BASE_ATTRIBUTES = { location: 'episode_editor' };

const events = {
  creationToolClicked: attributes => {
    trackEvent(
      'creation_tool_clicked',
      { ...BASE_ATTRIBUTES, ...attributes },
      { providers: [mParticle] }
    );
  },
  fileUploaded: () => {
    trackEvent(
      'file_uploaded',
      {
        ...BASE_ATTRIBUTES,
        method: 'drag_and_drop',
        component: 'EpisodeEditorStagingArea',
      },
      { providers: [mParticle] }
    );
  },
  recordANewSegmentButtonClicked: () => {
    trackEvent(
      'record_a_new_segment_button_clicked',
      {
        ...BASE_ATTRIBUTES,
      },
      { providers: [mParticle] }
    );
  },
  newRecordingButtonClicked: () => {
    trackEvent(
      'new_recording_button_clicked',
      {
        ...BASE_ATTRIBUTES,
      },
      { providers: [mParticle] }
    );
  },
  mobileRecordingButtonClicked: () => {
    trackEvent(
      'mobile_recording_button_clicked',
      {
        ...BASE_ATTRIBUTES,
      },
      { providers: [mParticle] }
    );
  },
  startRecordingButtonClicked: () => {
    trackEvent(
      'start_recording_button_clicked',
      { ...BASE_ATTRIBUTES },
      { providers: [mParticle] }
    );
  },
  stopRecordingButtonClicked: attributes => {
    trackEvent(
      'stop_recording_button_clicked',
      { ...BASE_ATTRIBUTES, ...attributes },
      { providers: [mParticle] }
    );
  },
  recordingInputSelected: () => {
    trackEvent(
      'recording_input_selected',
      { ...BASE_ATTRIBUTES },
      {
        providers: [mParticle],
      }
    );
  },
  saveButtonClicked: () => {
    trackEvent(
      'save_button_clicked',
      { ...BASE_ATTRIBUTES },
      {
        providers: [mParticle],
      }
    );
  },
  previewButtonClicked: attributes => {
    trackEvent(
      'preview_button_clicked',
      { ...BASE_ATTRIBUTES, ...attributes },
      {
        providers: [mParticle],
      }
    );
  },
  segmentDragAndDropped: attributes => {
    trackEvent(
      'segment_drag_and_dropped',
      { ...BASE_ATTRIBUTES, ...attributes },
      {
        providers: [mParticle],
      }
    );
  },
  createEpisodePageViewed: () => {
    trackEvent('InitiateCheckout', {}, { providers: [fbq] });
  },
  recordEpisodePageViewed: () => {
    trackEvent('AddPaymentInfo', {}, { providers: [fbq] });
  },
  episodeCreated: () => {
    trackEvent('episode_created', {}, { providers: [mParticle] });
  },
  segmentAdded: () => {
    trackEvent('segment_added', {}, { providers: [mParticle] });
  },
  musicAdded: attributes => {
    trackEvent(
      'episode_builder_music_added',
      { ...attributes },
      { providers: [mParticle] }
    );
  },
  musicConfirmationClicked: () => {
    trackEvent(
      'episode_builder_music_confirmation_clicked',
      {},
      { providers: [mParticle] }
    );
  },
  learnMoreClicked: () => {
    trackEvent(
      'episode_builder_music_confirmation_learn_more_clicked',
      {},
      { providers: [mParticle] }
    );
  },
  spotifyOAuthConnected: () => {
    trackEvent(
      'episode_builder_spotify_connected',
      {},
      { providers: [mParticle] }
    );
  },
  audioMarkedAsExternalAd: attributes => {
    trackEvent(
      'episode_builder_external_ad_marked',
      { ...attributes },
      { providers: [mParticle] }
    );
  },
  audioUnmarkedAsExternalAd: attributes => {
    trackEvent(
      'episode_builder_external_ad_unmarked',
      { ...attributes },
      { providers: [mParticle] }
    );
  },
  episodeSubmitted: () => {
    trackEvent('episode_editor_submitted', {}, { providers: [mParticle] });
  },
  tabClicked: ({ tab }) => {
    trackEvent(
      `episode_builder_${tab}_tab_clicked`,
      {},
      { providers: [mParticle] }
    );
  },
};

export default events;
